<template>
    <div v-if="disabled || isExpanded" v-html="getText()" v-bind="$attrs"></div>

    <div v-if="!isExpanded && !disabled" v-bind="$attrs">
        <span v-html="$filters.truncate(getText(), maxLength, '... ')"></span>
        <a class="underline" v-if="!isExpanded && getText().length > maxLength" @click="isExpanded = true">Läs mer</a>
    </div>

    <div v-if="isExpanded && !disabled" v-bind="$attrs">
        <a class="underline" v-if="isExpanded" @click="isExpanded = false">Dölj</a>
    </div>
</template>

<script>
    export default {
        props: {
            maxLength: { type: Number, default: 250 },
            disabled: { type: Boolean, default: false },
            expanded: { type: Boolean, default: false },
        },

        data () {
            return {
                isExpanded: false,
            }
        },

        mounted () {
            this.isExpanded = this.expanded;
        },

        methods: {
            getText () {
                return this.$slots.default()[0].children.trim().replace(/\n/, '').replace(/\n/g, "<br />");
            },

            hide() {
                this.isExpanded = false;
            }
        }
    }
</script>
